import Api from "./api"

const ReportsService = {

  getReport: async (params) => {
    let response = await Api.post("/reports/getReport", params,
    {
      headers: {
      "auth-token": localStorage.getItem("auth-token"),
      "keep-logged": localStorage.getItem("keep-logged") 
      }
    })
    localStorage.setItem("auth-token", response.headers["auth-token"])
    return response
  },

}

export default ReportsService